import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const UpdateProgramMutation = graphql(`
    mutation UpdateProgram($id: ObjectID!, $input: UpdateProgramInput!) {
        updateProgram(id: $id, input: $input) {
            __typename
            ... on UpdateProgramSuccessfulResponse {
                result {
                    ...ProgramItemData
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export type UpdateProgramMutationVariables = VariablesOf<typeof UpdateProgramMutation>;
